import { render, staticRenderFns } from "./singlesoview.vue?vue&type=template&id=77b652d1&scoped=true&"
import script from "./singlesoview.vue?vue&type=script&lang=js&"
export * from "./singlesoview.vue?vue&type=script&lang=js&"
import style0 from "./singlesoview.vue?vue&type=style&index=0&id=77b652d1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b652d1",
  null
  
)

export default component.exports